import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import AOS from 'aos';
import vuexI18n from 'vuex-i18n';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'aos/dist/aos.css';
import translations from './translations';

// bootstrap
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

// translations
Vue.use(vuexI18n.plugin, new Vuex.Store({}), {
  moduleName: 'i18n',
  onTranslationNotFound(locale, key) {
    console.warn('onTranslationNotFound', locale, key);
  },
});
const lang = translations(Vue);

new Vue({
  created() {
    AOS.init();
  },
  router,
  store,
  render: (h) => h(App),
  lang,
}).$mount('#app');
